module.exports = __webpack_public_path__ + "media/images/iconSocialShare__inactive--dark-8f3f79a183863e3d9ee967bf45283ebf.png";